import React from 'react';

import { ReactComponent as TariffEndIcon } from '../../assets/tariffEnd.svg';
import './style.scss';

const TariffEndScreen = props => (
    <div className="screen tariffEnd">
        <div className="screen_icon">
            <TariffEndIcon />
        </div>
        <p className="screen_title">Увы, модуль пока недоступен... :(</p>
        <p className="screen_desc">Скорее всего, срок действия Вашего тарифа закончился. Свяжитесь со службой поддержки для уточнения деталей.</p>
    </div>
);


export default TariffEndScreen;
